import { DocumentationKeys } from '@retail/products/types';

export const documentationKeys: DocumentationKeys[] = [
  'buildingProductDeclarationUrl',
  'informationSheetUrl',
  'safetyDataSheetUrl',
  'userManualUrl',
  'declarationOfPerformanceUrl',
  'assemblyInstructionsUrl',
  // 'spaceImageFrontUrl',
  // 'spaceImageAboveUrl',
  // 'spaceImageLeftUrl',
  'threeDimensionalImageUrl',
  'explodedViewImageUrl',
  'lineSketchDrawingUrl',
];
